import React from "react";
import { SaveLine1 } from "../../icons/SaveLine1";
import "./style.css";

export const SaveLineWrapper = () => {
  return <SaveLine1 className="save-line" />;
};
